import React, { useState, useEffect } from 'react'

import '../../sytles/button.scss'

const BingoSquareJ = () => {
    const [clicked, setClicked ] = useState(window.localStorage.getItem('toggleBtnHandler10') === 'true')

    useEffect(() => {
      window.localStorage.setItem('toggleBtnHandler10', clicked)
    }, [clicked]);

    const toggleBtnHandler = () => {
      setClicked(!clicked)
    }  

     {
      const styles = ['button']
      let text = 'Any tome!'
      let bodyEl = document.body
      bodyEl.style.background = '#1f1f1f'
      
      if (clicked) {
        styles.push('clicked')
        text = 'Any tome!';
        bodyEl.style.background = '#EEE'
      } 
      return (
     <div className={`main ${clicked ? "toggleBtnHandler": ''}`}>
        <div className={BingoSquareJ}>
            <button className={styles.join(' ')} onClick={toggleBtnHandler}>{text}</button>
        </div>
     </div>
      )
    }
  }

  export default BingoSquareJ
  
